import React, { use, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import OrganizationAssignedUsers from "./OrganizationAssignedUsers";
import {
    Dialog,
    DialogContent,
    Modal,
    Button,
    TextField,
    Tabs,
    Tab,
    Box,
    Alert,
    IconButton,
    Checkbox,
    FormControlLabel,
    Grid
} from "@mui/material";
import InputSwitch from "../../../../components/Admin/Inputs/InputSwitch";
import { getApiOrganizationUpdate, getApiOrganizationCreate, getApiOrganizationDelete, apiOrganizationUpdateVerifactu } from "../../../../services/Admin/organizations";
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { set } from "date-fns";
import moment from "moment/moment";

export default function EditOrganizationModal({ open, onClose, organization, onUpdated, isCreate, isSuperAdmin, role }) {
    const [tab, setTab] = useState(0);
    const [logoFile, setLogoFile] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [showDelete, setShowDelete] = useState(false);
    const [removing, setRemoving] = useState(false);

    // Form
    const [name, setName] = useState();
    const [logo, setLogo] = useState();
    const [maxUserRoleWorkers, setMaxUserRoleWorkers] = useState();
    const [defaultServiceMarginMinutes, setDefaultServiceMarginMinutes] = useState();
    const [removeLogo, setRemoveLogo] = useState(false);
    const [nif, setNif] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [ibanCc, setIbanCc] = useState("");
    const [postalCode, setPostalCode] = useState("");

    // Campos para la nueva pestaña VeriFactu
    const [verifactuCertificado, setVerifactuCertificado] = useState(null);
    const [verifactuEnvioAuto, setVerifactuEnvioAuto] = useState(false);
    const [verifactuCertificadoPassword, setVerifactuCertificadoPassword] = useState(null);
    const [verifactuDescripcionOperacion, setVerifactuDescripcionOperacion] = useState("");
    const [verifactuCertificadoFechaExpiracion, setVerifactuCertificadoFechaExpiracion] = useState(null);

    const handleTabChange = (e, v) => setTab(v);

    useEffect(() => {
        setName(organization?.name || "");
        setLogo(organization?.logo || "");
        setMaxUserRoleWorkers(organization?.max_user_role_workers || null);
        setDefaultServiceMarginMinutes(organization?.default_service_margin_minutes ?? 5);
        setNif(organization?.nif || "");
        setCity(organization?.city || "");
        setAddress(organization?.address || "");
        setPostalCode(organization?.postalCode || "");
        setIbanCc(organization?.ibanCc || "");
        setRemoveLogo(false);
        setLogoFile(null);
        setError("");
        setShowDelete(false);
        setTab(0);
        setVerifactuCertificado(organization?.verifactu_certificado || null);
        setVerifactuEnvioAuto(organization?.verifactu_envio_auto || false);
        setVerifactuCertificadoPassword(organization?.verifactu_certificado_password || null);
        setVerifactuDescripcionOperacion(organization?.verifactu_descripcion_operacion || "");
        setVerifactuCertificadoFechaExpiracion(organization?.verifactu_certificado_fecha_expiracion || null);

    }, [organization, open, isCreate]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                        backdropFilter: "blur(5px)",
                    },
                },
            }}
        >
            <DialogContent style={{ padding: 20, position: "relative", borderRadius: 12 }}>
                {/* Botón de cerrar arriba derecha */}
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        zIndex: 10
                    }}
                    aria-label="Cerrar"
                >
                    <CloseIcon />
                </IconButton>

                {/* Header con tabs centradas, sin botón de cerrar */}
                <Box sx={{ mb: 2, textAlign: 'center' }}>
                    {!isCreate ? (
                        <>
                            <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" centered>
                                <Tab label="Datos" />
                                <Tab label="Admin" style={{ display: isSuperAdmin ? 'block' : 'none' }} />
                                <Tab label="Gestores" style={{ display: isSuperAdmin ? 'block' : 'none' }} />
                                <Tab label="Trabajadores" style={{ display: isSuperAdmin ? 'block' : 'none' }} />
                                <Tab label="Clientes" style={{ display: isSuperAdmin ? 'block' : 'none' }} />
                                <Tab label="VeriFactu" />
                            </Tabs>
                        </>
                    ) : null}
                </Box>
                {(tab === 0 || isCreate) && (
                    <GestionarDatos
                        logo={logo}
                        setName={setName}
                        name={name}
                        setLogo={setLogo}
                        setLogoFile={setLogoFile}
                        setRemoveLogo={setRemoveLogo}
                        maxUserRoleWorkers={maxUserRoleWorkers}
                        setMaxUserRoleWorkers={setMaxUserRoleWorkers}
                        defaultServiceMarginMinutes={defaultServiceMarginMinutes}
                        setDefaultServiceMarginMinutes={setDefaultServiceMarginMinutes}
                        isCreate={isCreate}
                        setShowDelete={setShowDelete}
                        showDelete={showDelete}
                        removing={removing}
                        saving={saving}
                        organization={organization}
                        onUpdated={onUpdated}
                        setError={setError}
                        setTab={setTab}
                        open={open}
                        setSaving={setSaving}
                        removeLogo={removeLogo}
                        logoFile={logoFile}
                        onClose={onClose}
                        setRemoving={setRemoving}
                        nif={nif}
                        setNif={setNif}
                        ibanCc={ibanCc}
                        setIbanCc={setIbanCc}
                        city={city}
                        setCity={setCity}
                        address={address}
                        setAddress={setAddress}
                        postalCode={postalCode}
                        setPostalCode={setPostalCode}
                        isSuperAdmin={isSuperAdmin}
                    />
                )}
                {isSuperAdmin ? (
                    <>
                        {tab === 1 && !isCreate && (
                            <OrganizationAssignedUsers organization_id={organization?.id} onClose={onClose} role_code="ROLE_ADMIN" maxUserRoleWorkers={maxUserRoleWorkers} isSuperAdmin={isSuperAdmin} />
                        )}
                        {tab === 2 && !isCreate && (
                            <OrganizationAssignedUsers organization_id={organization?.id} onClose={onClose} role_code="ROLE_MANAGER" maxUserRoleWorkers={maxUserRoleWorkers} isSuperAdmin={isSuperAdmin} />
                        )}
                        {tab === 3 && !isCreate && (
                            <OrganizationAssignedUsers organization_id={organization?.id} onClose={onClose} role_code="ROLE_WORKER" maxUserRoleWorkers={maxUserRoleWorkers} isSuperAdmin={isSuperAdmin} />
                        )}
                        {tab === 4 && !isCreate && (
                            <OrganizationAssignedUsers organization_id={organization?.id} onClose={onClose} role_code="ROLE_CLIENT" maxUserRoleWorkers={maxUserRoleWorkers} isSuperAdmin={isSuperAdmin} />
                        )}
                    </>
                ) : null}
                {tab === 5 && !isCreate && (
                    <VerifactuTab
                        organization={organization}
                        verifactuCertificado={verifactuCertificado}
                        setVerifactuCertificado={setVerifactuCertificado}
                        verifactuEnvioAuto={verifactuEnvioAuto}
                        setVerifactuEnvioAuto={setVerifactuEnvioAuto}
                        verifactuCertificadoPassword={verifactuCertificadoPassword}
                        setVerifactuCertificadoPassword={setVerifactuCertificadoPassword}
                        verifactuDescripcionOperacion={verifactuDescripcionOperacion}
                        setVerifactuDescripcionOperacion={setVerifactuDescripcionOperacion}
                        verifactuCertificadoFechaExpiracion={verifactuCertificadoFechaExpiracion}
                        isCreate={isCreate}
                        onClose={onClose}
                    />
                )}
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            </DialogContent>
        </Dialog>
    );
}

function GestionarDatos({ logo, setName, name, setLogo, setLogoFile, setRemoveLogo, maxUserRoleWorkers, setMaxUserRoleWorkers, defaultServiceMarginMinutes, setDefaultServiceMarginMinutes, isCreate, setShowDelete, showDelete, removing, saving, organization, onUpdated, setError, setTab, open, setSaving, removeLogo, logoFile, onClose, setRemoving, nif, setNif, city, setCity, address, setAddress, postalCode, setPostalCode, isSuperAdmin, ibanCc, setIbanCc }) {
    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setLogo(URL.createObjectURL(file));
        }
    };

    const handleSave = async () => {
        setSaving(true);
        setError("");
        try {
            const f = new FormData();
            f.append('name', name);
            f.append('remove_logo', removeLogo ? '1' : '0');
            if (logoFile) {
                f.append('logo', logoFile);
            } else {
                f.append('logo', '');
            }
            f.append('max_user_role_workers', maxUserRoleWorkers || null);
            f.append('default_service_margin_minutes', defaultServiceMarginMinutes ?? 5);
            f.append('nif', nif || '');
            f.append('city', city || '');
            f.append('ibanCc', ibanCc || '');
            f.append('address', address || '');
            f.append('postal_code', postalCode || '');
            if (isCreate) {
                await getApiOrganizationCreate(f);
            } else {
                await getApiOrganizationUpdate(organization.id, f);
            }

            onUpdated && onUpdated();
            onClose();
        } catch (err) {
            setError("Error al guardar los cambios");
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async () => {
        setRemoving(true);
        setError("");
        try {
            await getApiOrganizationDelete(organization.id);
            onUpdated && onUpdated();
            onClose();
        } catch (err) {
            setError("Error al eliminar la organización");
        } finally {
            setRemoving(false);
        }
    };

    return (
        <>
            <Box display="flex" flexDirection="column" gap={2}>
                <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                    {logo && (
                        <Box
                            sx={{
                                width: 'auto',
                                height: 90,
                                mb: 1,
                                border: '1.5px solid #e3e6ee',
                                borderRadius: '12px',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden',
                                p: 1
                            }}
                        >
                            <img
                                src={logo}
                                alt="logo preview"
                                style={{ maxHeight: 70, maxWidth: 120, objectFit: 'contain', display: 'block', margin: '0 auto' }}
                            />
                        </Box>
                    )}
                    <Box display="flex" gap={1} alignItems="center">
                        {logo ? (
                            <>
                                <Button
                                    variant="outlined"
                                    color="inherit"
                                    onClick={() => { setLogo(''); setLogoFile(null); setRemoveLogo(true); }}
                                    sx={{ alignSelf: 'flex-start', color: '#888', fontWeight: 500, borderColor: '#e0e0e0', background: '#fff', px: 2, py: 0.5 }}
                                >
                                    Eliminar logo
                                </Button>



                                <label htmlFor="logo-upload" style={{ marginBottom: 0 }}>
                                    <input
                                        accept="image/*"
                                        id="logo-upload"
                                        type="file"
                                        style={{ display: 'none' }}
                                        onChange={handleLogoChange}
                                    />
                                    <Button
                                        variant="outlined"
                                        color="inherit"
                                        component="span"
                                        sx={{ alignSelf: 'flex-start', color: 'rgb(80, 70, 228) !important', fontWeight: 500, borderColor: 'rgb(80, 70, 228) !important', px: 2, py: 0.5, marginLeft: 1 }}
                                    >
                                        Cambiar logo
                                    </Button>
                                </label>
                            </>
                        ) : (
                            <label htmlFor="logo-upload" style={{ marginBottom: 0 }}>
                                <input
                                    accept="image/*"
                                    id="logo-upload"
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={handleLogoChange}
                                />

                                <Button
                                    variant="outlined"
                                    color="inherit"
                                    component="span"
                                    sx={{ alignSelf: 'flex-start', color: 'rgb(80, 70, 228) !important', fontWeight: 500, borderColor: 'rgb(80, 70, 228) !important', px: 2, py: 0.5, marginLeft: 1 }}
                                >
                                    Seleccionar logo
                                </Button>
                            </label>
                        )}
                    </Box>
                </Box>
                <TextField
                    label="Nombre de la organización"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    disabled={!isSuperAdmin}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="NIF"
                    value={nif}
                    onChange={e => setNif(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="IBAN"
                    value={ibanCc}
                    onChange={e => setIbanCc(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="Ciudad"
                    value={city}
                    onChange={e => setCity(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="Dirección"
                    value={address}
                    onChange={e => setAddress(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="Codigo postal"
                    value={postalCode}
                    onChange={e => setPostalCode(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="Cantidad maxima de usuarios con rol Trabajador"
                    value={maxUserRoleWorkers}
                    onChange={e => setMaxUserRoleWorkers(e.target.value)}
                    disabled={!isSuperAdmin}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                <TextField
                    label="Margen por defecto entre servicios (minutos)"
                    type="number"
                    value={defaultServiceMarginMinutes}
                    onChange={e => setDefaultServiceMarginMinutes(e.target.value)}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    size="small"
                />

                {showDelete && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        ¿Estás seguro de que quieres eliminar esta organización?
                        <Box mt={1} display="flex" gap={2}>
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={handleDelete}
                                disabled={removing}
                                sx={{ borderColor: '#e57373', color: '#c62828', background: '#fff', fontWeight: 500 }}
                            >
                                Sí, eliminar
                            </Button>
                            <Button variant="outlined" onClick={() => setShowDelete(false)}>
                                Cancelar
                            </Button>
                        </Box>
                    </Alert>
                )}

                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16, marginTop: 20 }}>
                    <div style={{ width: "50%" }}>
                        {!isCreate && isSuperAdmin ? (
                            <Button
                                onClick={() => setShowDelete(true)}
                                variant="contained"
                                className="MuiButton-containedCancel"
                                fullWidth
                            >
                                Eliminar
                            </Button>
                        ) : null}
                    </div>
                    <div style={{ width: "50%" }}>
                        <Button
                            onClick={handleSave}
                            color="primary"
                            variant="contained"
                            fullWidth
                        >
                            Guardar
                        </Button>
                    </div>
                </div>
            </Box>
        </>
    )
}

function VerifactuTab({
    organization,
    verifactuCertificado,
    setVerifactuCertificado,
    verifactuEnvioAuto,
    setVerifactuEnvioAuto,
    verifactuCertificadoPassword,
    setVerifactuCertificadoPassword,
    verifactuDescripcionOperacion,
    setVerifactuDescripcionOperacion,
    verifactuCertificadoFechaExpiracion,
    isCreate,
    onClose,
    setError
}) {
    // VeriFactu save state
    const [verifactuSaving, setVerifactuSaving] = useState(false);
    const [verifactuError, setVerifactuError] = useState("");

    // Password management show/hide
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    const handleCertificadoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setVerifactuCertificado(file);
        }
    };

    // Handler for saving VeriFactu tab data
    const handleVerifactuSave = async () => {
        setVerifactuSaving(true);
        setVerifactuError("");
        // --- Check file extension before sending ---
        if (verifactuCertificado) {
            const ext = verifactuCertificado.name.split('.').pop().toLowerCase();
            if (ext !== "p12" && ext !== "pfx") {
                setVerifactuError("Solo se permiten certificados en formato .p12 o .pfx para VeriFactu.");
                setVerifactuSaving(false);
                return;
            }
        }
        try {
            const f = new FormData();
            if (verifactuCertificado) {
                f.append('verifactu_certificado', verifactuCertificado);
            }
            f.append('verifactu_envio_auto', verifactuEnvioAuto ? '1' : '0');
            f.append('verifactu_certificado_password', verifactuCertificadoPassword || '');
            f.append('verifactu_descripcion_operacion', verifactuDescripcionOperacion || '');

            if (!isCreate) {
                await apiOrganizationUpdateVerifactu(organization.id, f);
            }
            onClose();
        } catch (err) {
            setError("Error al guardar los datos de VeriFactu");
        } finally {
            setVerifactuSaving(false);
        }
    };


    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box>
                        <label htmlFor="verifactu-certificado-upload">
                            <input
                                accept=".p12,.pfx" // Solo aceptar certificados p12 o pfx
                                id="verifactu-certificado-upload"
                                name="verifactu_certificado"
                                type="file"
                                style={{ display: 'none' }}
                                onChange={handleCertificadoChange}
                            />
                            <Button
                                variant="outlined"
                                color="inherit"
                                component="span"
                                sx={{ px: 2, py: 0.5 }}
                            >
                                {verifactuCertificado ? "Cambiar certificado" : "Seleccionar certificado"}
                            </Button>
                            {verifactuCertificado && (
                                <span style={{ marginLeft: 10 }}>{verifactuCertificado.name}</span>
                            )}
                            {(verifactuCertificadoFechaExpiracion && !verifactuCertificado) && (
                                <span>
                                    Certificado detectado. <br />
                                    Vigencia hasta: {moment(verifactuCertificadoFechaExpiracion * 1000).format('DD/MM/YYYY')}
                                </span>
                            )}
                        </label>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} alignItems="end" display="flex" flexDirection="column">
                    <InputSwitch
                        checked={verifactuEnvioAuto}
                        onChange={e => setVerifactuEnvioAuto(e.target.checked)}
                        name="verifactu_envio_auto"
                        color="primary"
                        label="Envío automático"
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField
                        label="Contraseña del certificado"
                        name="verifactu_certificado_password"
                        value={verifactuCertificadoPassword}
                        onChange={e => setVerifactuCertificadoPassword(e.target.value)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        type={showPassword ? "text" : "password"}
                        autoComplete="off"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        tabIndex={"-1"}
                                        style={{ paddingTop: "0px" }}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField
                        label="Desc. concepto facturación (aplicado a las facturas enviadas automáticamente)"
                        value={verifactuDescripcionOperacion}
                        onChange={e => setVerifactuDescripcionOperacion(e.target.value)}
                        multiline
                        minRows={4}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        size="small"
                    />
                </Grid>
            </Grid>
            {verifactuError && (
                <Alert severity="error" sx={{ mt: 2 }}>{verifactuError}</Alert>
            )}
            <Box display="flex" justifyContent="flex-end" width="100%" mt={2}>
                <Button
                    onClick={handleVerifactuSave}
                    color="primary"
                    variant="contained"
                    fullWidth
                    disabled={(verifactuSaving && !isCreate)}
                >
                    Guardar
                </Button>
            </Box>
        </Box>
    );
}